import { FilterStoreType } from './storeTypes';
import { DateTime } from 'luxon';

export const FiltersDefaultStore: FilterStoreType = {
	dateTime: {
		start: DateTime.now(),
		end: DateTime.now(),
	},
};
